import type { AjudaDaPagina, ChaveDePagina } from "./tipos";

export const AJUDA_DA_CONTA = {
  equipe: {
    titulo: "Equipe",
    resumo: "Quem faz parte da organização, o acesso de cada um e como está o dia dos profissionais.",
    passos: [
      "Para convidar: clique em Convidar, informe o e-mail e o papel e envie. Para vários de uma vez, use Convidar mais de um e cole a lista de e-mails.",
      "Para acompanhar o dia: a aba Visão geral mostra quem está em atendimento, as consultas de hoje e os trabalhos em produção.",
      "Para mudar o que alguém pode fazer: em Membros e acessos, abra o membro e use Alterar acesso.",
      "Para afastar alguém: no menu de ações do membro, use Suspender (dá para reativar) ou Remover.",
      "Para convites pendentes: reenvie, copie o link ou revogue na lista de convites.",
    ],
    dicas: [
      "Só quem pode gerenciar a equipe vê a lista de membros e pode convidar.",
      "A organização pessoal não aceita convites: crie uma organização de equipe em Organizações.",
      "Acesso personalizado, com permissões sob medida, faz parte dos planos pagos.",
    ],
  },
  organizacoes: {
    titulo: "Organizações",
    resumo: "As organizações em que você está, a pessoal e as de equipe, para ver, trocar e criar.",
    passos: [
      "Para ver o resumo de uma organização: clique no cartão dela.",
      "Para trocar de organização: use o ícone de troca no cartão. No celular, escolha no seletor e toque em Trocar pra essa organização.",
      "Para abrir uma clínica ou laboratório novo: clique em Criar organização e preencha os dados.",
    ],
    dicas: [
      "Você sempre tem uma organização pessoal; só as organizações de equipe podem convidar outros membros.",
      "O cartão mostra quantos avisos não lidos cada organização tem.",
      "Dá para trocar também pelo seletor de organização no topo da tela.",
    ],
  },
  "apps-pro": {
    titulo: "Apps Pro",
    resumo: "Os aplicativos profissionais com IA que estão chegando à plataforma.",
    passos: [
      "Para conhecer: veja os cartões DICOM Viewer Pro, Raio X - IA, Radiologia Template IA e Paciente Virtual.",
      "Para saber o que já dá para usar: confira o selo de cada app (Disponível, Beta ou Em Breve).",
    ],
    dicas: ["Por enquanto todos estão Em Breve; a página é atualizada conforme os apps chegam."],
  },
  menu: {
    titulo: "Menu",
    resumo: "Todas as áreas da plataforma em cartões, com os mesmos itens do menu lateral.",
    passos: [
      "Para ir a uma área: clique no cartão dela.",
      "Para mudar a ordem (no celular): toque em Reorganizar menu, arraste os itens pela alça e toque em Concluir.",
      "Para voltar à ordem original: use Voltar à ordem padrão.",
    ],
    dicas: [
      "Só aparecem as áreas que o tipo de organização, as suas permissões e o plano liberam.",
      "A ordem que você escolher fica salva na sua conta.",
    ],
  },
  notificacoes: {
    titulo: "Notificações",
    resumo: "Os avisos de todas as suas organizações, como convites aceitos, pedidos e pacientes que se cadastraram pelo link.",
    passos: [
      "Para focar no que falta ver: alterne entre Todas e Não lidas.",
      "Para abrir: clique no aviso. Ele é marcado como lido e leva ao que aconteceu.",
      "Para limpar: use Marcar todas como lidas, ou apague um aviso pela lixeira.",
    ],
    dicas: [
      "Cada aviso mostra de qual organização veio.",
      "Quais avisos você recebe, e com que som, se escolhe em Minha conta › Notificações.",
    ],
  },
  conta: {
    titulo: "Meu perfil",
    resumo: "O que é seu e vale em todas as organizações: dados profissionais, organizações, contato, senha, avisos, privacidade e aparência.",
    passos: [
      "Para foto, nome, CRO, especialidades e biografia: abra Dados profissionais.",
      "Para ver suas organizações e entrar numa delas: abra Organizações. Telefone, CPF e e-mails: Contato.",
      "Para senha e PIN de segurança: abra Segurança.",
      "Para avisos e sons: abra Notificações. Para o estilo do menu: Aparência.",
      "Para baixar seus dados ou pedir a exclusão da conta: abra Privacidade e dados.",
    ],
    dicas: ["As configurações da organização (dados, agenda, permissões) ficam em Configurações."],
  },
  "conta:perfil": {
    titulo: "Meu perfil · Dados profissionais",
    resumo: "Sua foto, nome, CRO, especialidades e biografia. Vale em todas as organizações.",
    passos: [
      "Para trocar a foto: no topo, clique na foto e escolha uma imagem (até cerca de 500 KB).",
      "Para mudar nome, CRO, especialidades ou biografia: edite e clique em Salvar.",
      "Os números do topo levam às telas de cada um: pacientes, agenda e prótese.",
    ],
    dicas: [
      "Alterar o CRO deixa o registro como pendente até a verificação; o selo ao lado do CRO mostra a situação.",
      "Suas especialidades são só suas: não mudam os procedimentos da clínica, que ficam em Configurações › Especialidades.",
      "Os números somam todas as suas organizações, só onde o seu papel deixa ver aquela tela.",
    ],
  },
  "conta:organizacoes": {
    titulo: "Meu perfil · Organizações",
    resumo: "As organizações em que você está, com o seu papel em cada uma.",
    passos: ["Para ir para uma delas: clique em Entrar na linha dela."],
    dicas: ["Para criar uma organização nova ou sair de uma: use a página Organizações, pelo seletor no topo."],
  },
  "conta:contato": {
    titulo: "Meu perfil · Contato",
    resumo: "Seu telefone, CPF e e-mails.",
    passos: [
      "Para mudar telefone ou CPF: edite os campos e clique em Salvar.",
      "Para usar outro e-mail: em Meus e-mails, clique em Adicionar e-mail e confirme pelo link enviado a ele.",
    ],
    dicas: ["Um e-mail adicional confirmado serve para aceitar convites de equipe enviados a ele."],
  },
  "conta:seguranca": {
    titulo: "Minha conta · Segurança",
    resumo: "Sua senha de acesso e o PIN de segurança.",
    passos: [
      "Para trocar a senha: informe a senha atual, a nova (mínimo de 8 caracteres), confirme e clique em Alterar senha.",
      "Para criar o PIN: clique em Criar PIN.",
      "Para trocar o PIN: clique em Redefinir PIN e confirme com a senha da conta.",
    ],
    dicas: ["O PIN é pedido ao mudar preços, transferir a organização ou dar o papel de Sócio."],
  },
  "conta:preferencias": {
    titulo: "Minha conta · Preferências",
    resumo: "Como você recebe avisos (som e canais de cada tipo) e o estilo do menu lateral.",
    passos: [
      "Para ligar ou desligar o som: em Som, use Ativar som.",
      "Para escolher os canais: em Tipos de aviso, marque Plataforma, E-mail ou WhatsApp para cada tipo.",
      "Para gravar os avisos: clique em Salvar preferências (Descartar desfaz o que não foi salvo).",
      "Para mudar o menu: em Aparência, escolha Compacto, Clássico ou Colorido. Vale na hora, sem salvar.",
    ],
    dicas: [
      "O som só toca com a aba do DentalBook aberta.",
      "E-mail e WhatsApp já guardam a sua escolha, mas o envio começa quando a integração for ativada. O sino funciona hoje.",
      "O estilo do menu fica guardado neste navegador.",
    ],
  },
  "conta:privacidade": {
    titulo: "Minha conta · Privacidade e dados",
    resumo: "Seus direitos na LGPD: baixar seus dados, pedir reset ou exclusão e liberar o acesso do suporte.",
    passos: [
      "Para baixar seus dados: clique em Baixar meus dados. Vem um arquivo com cadastro, e-mails, vínculos com organizações e preferências.",
      "Para apagar os dados das organizações de que você é dona: use Pedir reset dos dados. Conta, organizações, equipe e configurações ficam.",
      "Para encerrar a conta: use Pedir exclusão da conta. Apaga a conta e os dados das organizações de que você é dona, sem volta.",
      "Para o suporte ver a sua tela: clique em Permitir acesso por 72 h. É só leitura, e você pode usar Revogar agora.",
    ],
    dicas: ["Reset e exclusão são feitos pelo suporte a partir do seu pedido. Você acompanha em Seus pedidos e recebe um e-mail quando for atendido."],
  },
} satisfies Partial<Record<ChaveDePagina, AjudaDaPagina>>;
